(() => {
  'use strict';
  const configElement = document.getElementById('ThemeConfig');
  const config = configElement ? JSON.parse(configElement.textContent) : {};
  const status = (text) => { const target = document.getElementById('GlobalStatus'); if (target) target.textContent = text; };
  let productRequest = null;
  let cartBusy = false;
  function setupHeroes(root = document) {
    root.querySelectorAll('[data-hero]').forEach((hero) => {
      if (hero.dataset.ready) return;
      hero.dataset.ready = 'true';
      const slides = [...hero.querySelectorAll('[data-slide]')];
      let index = 0;
      hero.addEventListener('click', (event) => {
        const control = event.target.closest('[data-hero-index],[data-hero-direction]');
        if (!control) return;
        index = control.hasAttribute('data-hero-index') ? Number(control.dataset.heroIndex) : (index + Number(control.dataset.heroDirection) + slides.length) % slides.length;
        slides.forEach((slide, i) => { slide.hidden = i !== index; slide.classList.toggle('is-active', i === index); });
        hero.querySelectorAll('[data-hero-index]').forEach((button, i) => button.setAttribute('aria-pressed', String(i === index)));
      });
    });
  }
  document.addEventListener('change', async (event) => {
    const option = event.target.closest('[data-option-value-id]');
    if (!option) return;
    const section = option.closest('[data-product-section]');
    if (!section) return;
    if (productRequest) productRequest.abort();
    productRequest = new AbortController();
    const request = productRequest;
    const picked = [...section.querySelectorAll('[data-option-value-id]:checked')].map((input) => input.dataset.optionValueId);
    const url = new URL(option.dataset.productUrl || section.dataset.productUrl, location.origin);
    url.searchParams.set('option_values', picked.join(','));
    url.searchParams.set('section_id', section.dataset.sectionId);
    const oldFocus = option.dataset.optionValueId;
    const quantity = section.querySelector('input[name="quantity"]')?.value;
    section.setAttribute('aria-busy', 'true');
    section.querySelectorAll('form[action*="/cart/add"] button').forEach((button) => { button.disabled = true; });
    try {
      const response = await fetch(url, { signal: request.signal });
      if (!response.ok) throw new Error(String(response.status));
      const responseText = await response.text();
      if (request.signal.aborted) return;
      const parsed = new DOMParser().parseFromString(responseText, 'text/html');
      const replacement = parsed.querySelector('[data-product-section]');
      if (!replacement) throw new Error('Missing product section');
      section.replaceWith(replacement);
      syncWishlist();
      const input = [...replacement.querySelectorAll('[data-option-value-id]')].find((element) => element.dataset.optionValueId === oldFocus);
      input?.focus({ preventScroll: true });
      const newQuantity = replacement.querySelector('input[name="quantity"]');
      if (newQuantity && quantity) { const step = Number(newQuantity.step) || 1; const minimum = Number(newQuantity.min) || 1; const maximum = Number(newQuantity.max) || Infinity; newQuantity.value = String(Math.max(minimum, Math.min(maximum, Math.floor(Number(quantity) / step) * step))); }
      const variant = replacement.querySelector('input[name="id"]');
      const cleanUrl = new URL(replacement.dataset.productUrl, location.origin);
      if (variant?.value) cleanUrl.searchParams.set('variant', variant.value);
      else cleanUrl.searchParams.set('option_values', picked.join(','));
      history.replaceState({}, '', cleanUrl.pathname + cleanUrl.search);
    } catch (error) {
      if (error.name === 'AbortError') return;
      section.removeAttribute('aria-busy');
      const errorElement = section.querySelector('.variant-error');
      if (errorElement) {
        errorElement.textContent = config.variantError + ' ';
        const retry = document.createElement('a');
        url.searchParams.delete('section_id');
        retry.href = url.pathname + url.search;
        retry.textContent = config.variantRetry;
        errorElement.append(retry);
      }
      status(config.variantError);
    }
  });
  async function changeCart(control, quantity) {
    if (cartBusy) return;
    const section = control.closest('[data-cart-section]');
    if (!section) return;
    cartBusy = true;
    const key = control.dataset.key;
    const row = control.closest('[data-line-key]');
    const position = [...section.querySelectorAll('[data-line-key]')].indexOf(row);
    const note = section.querySelector('[name="note"]')?.value || '';
    const hadRemoveFocus = control.matches('[data-cart-remove]');
    section.setAttribute('aria-busy', 'true');
    section.querySelectorAll('button,input,textarea').forEach((element) => element.disabled = true);
    let confirmed = false;
    try {
      const response = await fetch(config.cartChangeUrl + '.js', { method:'POST', headers:{'Content-Type':'application/json','Accept':'application/json'}, body:JSON.stringify({id:key,quantity,sections:[section.dataset.sectionId],sections_url:config.cartUrl}) });
      confirmed = response.ok;
      const result = await response.json();
      if (!response.ok) throw new Error(result.description || result.message || config.cartError);
      confirmed = true;
      if (!result.sections?.[section.dataset.sectionId]) {
        const refresh = await fetch(config.cartUrl + '?section_id=' + encodeURIComponent(section.dataset.sectionId));
        if (!refresh.ok) throw new Error(config.cartError);
        result.sections = { [section.dataset.sectionId]: await refresh.text() };
      }
      const parsed = new DOMParser().parseFromString(result.sections[section.dataset.sectionId], 'text/html');
      const replacement = parsed.querySelector('[data-cart-section]');
      if (!replacement) throw new Error(config.cartError);
      section.replaceWith(replacement);
      syncWishlist();
      const newNote = replacement.querySelector('[name="note"]');
      if (newNote) newNote.value = note;
      const rows = [...replacement.querySelectorAll('[data-line-key]')];
      const sameRow = rows.find((element) => element.dataset.lineKey === key);
      const focusRow = sameRow || rows[Math.min(position, rows.length - 1)];
      const focus = focusRow?.querySelector(hadRemoveFocus ? '[data-cart-remove]' : '[data-cart-quantity]') || replacement.querySelector('a,button');
      focus?.focus({ preventScroll: true });
      document.querySelectorAll('[data-cart-count]').forEach((element) => element.textContent = String(result.item_count));
      status(config.cartUpdated);
    } catch (error) {
      if (confirmed) { location.assign(config.cartUrl); return; }
      section.removeAttribute('aria-busy');
      section.querySelectorAll('button,input,textarea').forEach((element) => element.disabled = false);
      const errorElement = section.querySelector('.cart-error');
      errorElement.textContent = error.message || config.cartError;
      if (control.matches('[data-cart-quantity]')) control.value = control.defaultValue;
      control.focus({ preventScroll:true });
      status(errorElement.textContent);
    } finally { cartBusy = false; }
  }
  document.addEventListener('change', (event) => {
    const control = event.target.closest('[data-cart-quantity]');
    if (!control || !control.validity.valid) return;
    const quantity = Number(control.value);
    if (Number.isInteger(quantity) && quantity >= 0) changeCart(control, quantity);
  });
  document.addEventListener('click', (event) => {
    const remove = event.target.closest('[data-cart-remove]');
    if (remove) { event.preventDefault(); changeCart(remove, 0); }
  });
  document.addEventListener('keydown', (event) => { if (event.key === 'Escape') document.querySelectorAll('.nav-menu[open]').forEach((menu) => { menu.open = false; menu.querySelector('summary').focus(); }); });
  function prefillContact() {
    const field = document.querySelector('#ContactMessage');
    const query = new URLSearchParams(location.search);
    const product = query.get('product');
    if (field && !field.value && product) { field.value = 'Consulta de disponibilidad: ' + product + (query.get('sku') ? '\nSKU: ' + query.get('sku') : '') + '\n'; }
  }

  const wishlistKey = 'makishop-wishlist-products-v1';
  let wishlist = [];
  try {
    const stored = JSON.parse(localStorage.getItem(wishlistKey) || '[]');
    if (Array.isArray(stored)) wishlist = stored.filter((item) => item && /^\d+$/.test(String(item.id)) && typeof item.url === 'string' && item.url.startsWith('/') && !item.url.startsWith('//') && typeof item.title === 'string').slice(0, 100);
  } catch { status(config.wishlistStorageError); }
  function syncWishlist() {
    document.querySelectorAll('[data-wishlist-count]').forEach((element) => { element.textContent = String(wishlist.length); });
    document.querySelectorAll('[data-wishlist-toggle]').forEach((button) => { button.setAttribute('aria-pressed', String(wishlist.some((item) => item.id === button.dataset.productId))); });
  }
  function saveWishlist() {
    try { localStorage.setItem(wishlistKey, JSON.stringify(wishlist)); return true; }
    catch { status(config.wishlistStorageError); return false; }
  }
  function renderWishlist() {
    const list = document.querySelector('[data-wishlist-list]');
    if (!list) return;
    list.replaceChildren();
    document.querySelector('[data-wishlist-empty]').hidden = wishlist.length > 0;
    wishlist.forEach((item) => {
      const row = document.createElement('li');
      const link = document.createElement('a');
      link.href = item.url;
      link.textContent = item.title;
      const remove = document.createElement('button');
      remove.type = 'button';
      remove.dataset.wishlistRemove = item.id;
      remove.textContent = config.remove;
      remove.setAttribute('aria-label', config.remove + ': ' + item.title);
      row.append(link, remove);
      list.append(row);
    });
  }
  let wishlistOpener = null;
  document.addEventListener('click', (event) => {
    const toggle = event.target.closest('[data-wishlist-toggle]');
    if (toggle) {
      const id = toggle.dataset.productId;
      const oldWishlist = [...wishlist];
      const exists = wishlist.some((item) => item.id === id);
      if (exists) wishlist = wishlist.filter((item) => item.id !== id);
      else wishlist.push({id, title: toggle.dataset.productTitle, url: toggle.dataset.productUrl});
      if (!saveWishlist()) { wishlist = oldWishlist; return; }
      syncWishlist();
      status(exists ? config.wishlistRemoved : config.wishlistSaved);
    }
    const opener = event.target.closest('[data-wishlist-open]');
    if (opener) { wishlistOpener = opener; renderWishlist(); document.getElementById('WishlistDialog').showModal(); }
    if (event.target.closest('[data-wishlist-close]')) document.getElementById('WishlistDialog').close();
    const remove = event.target.closest('[data-wishlist-remove]');
    if (remove) {
      const index = wishlist.findIndex((item) => item.id === remove.dataset.wishlistRemove);
      const oldWishlist = [...wishlist];
      wishlist = wishlist.filter((item) => item.id !== remove.dataset.wishlistRemove);
      if (!saveWishlist()) { wishlist = oldWishlist; return; }
      syncWishlist();
      renderWishlist();
      const buttons = [...document.querySelectorAll('[data-wishlist-remove]')];
      (buttons[Math.min(index, buttons.length - 1)] || document.querySelector('[data-wishlist-close]')).focus();
      status(config.wishlistRemoved);
    }
  });
  document.getElementById('WishlistDialog')?.addEventListener('close', () => wishlistOpener?.focus());
  window.addEventListener('storage', (event) => {
    if (event.key !== wishlistKey) return;
    try { const stored = JSON.parse(event.newValue || '[]'); if (Array.isArray(stored)) { wishlist = stored.filter((item) => item && /^\d+$/.test(String(item.id)) && typeof item.url === 'string' && item.url.startsWith('/') && !item.url.startsWith('//') && typeof item.title === 'string').slice(0,100); syncWishlist(); if (document.getElementById('WishlistDialog')?.open) renderWishlist(); } }
    catch { status(config.wishlistStorageError); }
  });
  document.addEventListener('makishop:products-loaded', syncWishlist);
  syncWishlist();

  setupHeroes();

  function setupCountries() {
    document.querySelectorAll('[data-country-select]').forEach((country) => {
      const province = document.getElementById(country.dataset.provinceId);
      const chosen = [...country.options].find((option) => option.value === country.dataset.default || option.text === country.dataset.default);
      if (chosen) country.value = chosen.value;
      const update = () => {
        const selected = country.options[country.selectedIndex];
        let provinces = [];
        try { provinces = JSON.parse(selected.dataset.provinces || '[]'); } catch { provinces = []; }
        province.replaceChildren();
        provinces.forEach(([value, label]) => { const option = document.createElement('option'); option.value = value; option.textContent = label; option.selected = value === province.dataset.default || label === province.dataset.default; province.append(option); });
        province.closest('[data-province-wrapper]').hidden = provinces.length === 0;
        province.disabled = provinces.length === 0;
      };
      country.addEventListener('change', update);
      update();
    });
  }
  setupCountries();

  prefillContact();
  document.addEventListener('shopify:section:load', (event) => setupHeroes(event.target));
  document.addEventListener('shopify:block:select', (event) => { const slide = event.target.closest('[data-slide]'); if (slide) slide.closest('[data-hero]').querySelector('[data-hero-index="' + slide.dataset.slide + '"]')?.click(); });
})();
